export function setValueByPath<T extends object>(
  obj: T,
  path: string,
  value: unknown,
) {
  if (path !== '') {
    const steps = path.split('.');
    if (steps.length === 0) {
      console.warn(`An empty path was provoided ${path}`);
      return null;
    }
    if (steps.length === 1) {
      (obj as any)[steps[0]] = value;
    } else {
      const step = steps.shift()!;
      if (!(obj as any)[step]) (obj as any)[step] = {};
      setValueByPath((obj as any)[step], steps.join('.'), value);
    }
  }
}
